/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataModelRangeSetAggregation {
    GROUP = 'group',
    ZONE = 'zone',
    GROUP_ZONE = 'group-zone',
}
